import React from 'react';
import {Box, Button, DialogActions, DialogContent, DialogTitle, Typography} from '@mui/material';
import {ArchiveOutlined, RestoreOutlined} from '@mui/icons-material';
import {alpha} from '@mui/material/styles';
import {SettingsDialog} from '../settings/SettingsDialog';
import {getSettingsColors} from '../settings/SettingsDesign';

export function LandingDialog({sx = [], ...props}) {
    return <SettingsDialog {...props} sx={[{
        '& .MuiDialogContent-root': {position: 'relative', minWidth: 0},
        '& .MuiDialogTitle-root + .MuiDialogContent-root': {pt: 1.5},
        '& .MuiDialog-paper': {
            '& .MuiTextField-root': {my: 0},
            '& .MuiOutlinedInput-root': {bgcolor: theme => theme.palette.mode === 'light' ? theme.palette.background.paper : getSettingsColors(theme).input},
            '& .MuiOutlinedInput-input': {fontSize: 13},
            '& .MuiButton-root': {textTransform: 'none', boxShadow: 'none', minHeight: 36},
            '& .MuiAlert-root': {borderRadius: '10px', fontSize: 13, lineHeight: 1.7}
        }
    }, ...(Array.isArray(sx) ? sx : [sx])]}/>;
}

export function LandingSection({title, description, children}) {
    const titleId = React.useId();
    return <Box component="section" aria-labelledby={titleId} sx={{p: {xs: 2, sm: 2.5}, borderRadius: '12px',
        minWidth: 0, bgcolor: theme => getSettingsColors(theme).inset}}>
        <Typography component="h3" id={titleId} sx={{fontSize: 14, fontWeight: 600}}>{title}</Typography>
        {description && <Typography sx={{fontSize: 13, color: 'text.secondary', mt: 0.5, lineHeight: 1.6}}>{description}</Typography>}
        <Box sx={{mt: 2, display: 'grid', gap: 2, minWidth: 0}}>{children}</Box>
    </Box>;
}

export function LandingConfirmationDialog({confirm, action = 'archive', selectedCount = 1}) {
    const restoring = action === 'restore';
    const Icon = restoring ? RestoreOutlined : ArchiveOutlined;
    const label = restoring ? 'Restore' : 'Archive';
    const landings = selectedCount === 1 ? 'landing page' : `${selectedCount} landing pages`;
    return <LandingDialog open fullWidth maxWidth="xs" onClose={() => confirm(false)}
        aria-labelledby="landing-confirm-title" aria-describedby="landing-confirm-description"
        sx={{'& .MuiDialog-paper': {borderRadius: '16px'}}}>
        <DialogTitle id="landing-confirm-title">
            <Box sx={{display: 'flex', alignItems: 'center', gap: 1.5}}>
                <Box sx={{display: 'flex', p: 1, borderRadius: '10px', color: restoring ? 'primary.main' : 'error.main',
                    bgcolor: theme => alpha(restoring ? theme.palette.primary.main : theme.palette.error.main, 0.1)}}><Icon/></Box>
                <Box component="span">{label} {landings}?</Box>
            </Box>
        </DialogTitle>
        <DialogContent><Typography id="landing-confirm-description" sx={{fontSize: 14, color: 'text.secondary', lineHeight: 1.7}}>
            {restoring ? 'The selected landing pages will return to your active landing pages.' :
                'The selected landing pages will move to your archive. You can restore them from “View archived” at any time.'}
        </Typography></DialogContent>
        <DialogActions>
            <Button color="inherit" onClick={() => confirm(false)}>Cancel</Button>
            <Button variant="contained" color={restoring ? 'primary' : 'error'} onClick={() => confirm(true)}>{label} {selectedCount === 1 ? 'landing' : 'landings'}</Button>
        </DialogActions>
    </LandingDialog>;
}
